import { PageTypes } from '@shared/types';
export const getRowsByIcIndex = (icIndex, rows) => {
    return rows.filter(rowItem => rowItem.type !== PageTypes.certificate && rowItem.icIndex === icIndex);
};
